"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6093],{

/***/ 4973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2175);
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2676);


var _excluded = ["style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // eslint-disable-next-line no-undef



var _require = __webpack_require__(7271),
    WindowVirtualizer = _require.WindowVirtualizer,
    Virtualizer = _require.Virtualizer; // --- SessionStorage Availability Check ---


function isSessionStorageAvailable() {
  try {
    if ( false || typeof window.sessionStorage === "undefined") {
      return false;
    }

    var testKey = "__restorable_list_test__";
    window.sessionStorage.setItem(testKey, testKey);
    window.sessionStorage.removeItem(testKey);
    return true;
  } catch (_unused) {
    return false;
  }
} // virtua hides this element and opts each measured row back in with `visibility: visible`.
// WebKit will not request an <img> anywhere under a `visibility: hidden` ancestor, so Safari
// leaves the product shimmer up and never contacts the image host. Rows that are still
// unmeasured keep their own `visibility: hidden`, so showing the container does not flash them.


var ListSurface = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function ListSurface(_ref, ref) {
  var style = _ref.style,
      props = (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    style: _objectSpread(_objectSpread({}, style), {}, {
      visibility: "visible"
    })
  }));
});

var RestorableList = function RestorableList(_ref2) {
  var children = _ref2.children,
      _ref2$useVirtualizer = _ref2.useVirtualizer,
      useVirtualizer = _ref2$useVirtualizer === void 0 ? false : _ref2$useVirtualizer;
  var cacheKey = "window-list-cache-1";
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null); // Check if sessionStorage is available

  var isSessionStorageAvailable = function isSessionStorageAvailable() {
    try {
      var testKey = "__storage_test__";
      window.sessionStorage.setItem(testKey, testKey);
      window.sessionStorage.removeItem(testKey);
      return true;
    } catch (_unused2) {
      return false;
    }
  }; // Safe sessionStorage getter


  var safeGetItem = function safeGetItem(key) {
    try {
      if (isSessionStorageAvailable()) {
        var _window, _window$sessionStorag;

        return (_window = window) === null || _window === void 0 ? void 0 : (_window$sessionStorag = _window.sessionStorage) === null || _window$sessionStorag === void 0 ? void 0 : _window$sessionStorag.getItem(key);
      }

      return null;
    } catch (_unused3) {
      return null;
    }
  }; // Safe sessionStorage setter


  var safeSetItem = function safeSetItem(key, value) {
    try {
      if (isSessionStorageAvailable()) {
        var _window2, _window2$sessionStora;

        (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$sessionStora = _window2.sessionStorage) === null || _window2$sessionStora === void 0 ? void 0 : _window2$sessionStora.setItem(key, value);
      }
    } catch (_unused4) {// private mode / denied — silent
    }
  }; // Safe sessionStorage remover


  var safeRemoveItem = function safeRemoveItem(key) {
    try {
      if (isSessionStorageAvailable()) {
        var _window3, _window3$sessionStora;

        (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$sessionStora = _window3.sessionStorage) === null || _window3$sessionStora === void 0 ? void 0 : _window3$sessionStora.removeItem(key);
      }
    } catch (_unused5) {// private mode / denied — silent
    }
  }; // Add error handling for ResizeObserver


  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var handleError = function handleError(error) {
      if (error.message.includes("ResizeObserver")) {
        error.stopPropagation();
        return false;
      }
    };

    window.addEventListener("error", handleError);
    return function () {
      return window.removeEventListener("error", handleError);
    };
  }, []);

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var serialized;
    serialized = safeGetItem(cacheKey);
    if (!serialized) return [];

    try {
      return JSON.parse(serialized); // eslint-disable-next-line no-unused-vars
    } catch (e) {
      return [];
    }
  }, []),
      offset = _useMemo[0],
      cache = _useMemo[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function () {
    if (!ref.current) return;
    var handle = ref.current;
    window.scrollTo(0, offset !== null && offset !== void 0 ? offset : 0);
    safeRemoveItem(cacheKey);
    var scrollY = 0;

    var onScroll = function onScroll() {
      scrollY = window.scrollY;
    };

    window.addEventListener("beforeunload", function () {
      safeRemoveItem(cacheKey);
    });
    window.addEventListener("scroll", onScroll);
    onScroll();
    return function () {
      window.removeEventListener("scroll", onScroll); // Use stored window.scrollY because it may return 0 in useEffect cleanup

      safeSetItem(cacheKey, JSON.stringify([scrollY, handle.cache]));
    };
  }, [offset]);

  if (useVirtualizer) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Virtualizer, {
      as: ListSurface,
      children: children
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(WindowVirtualizer, {
    ref: ref,
    as: ListSurface,
    cache: cache,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RestorableList);

/***/ }),

/***/ 5847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ statusCopyClassName; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5271);
/* harmony import */ var _contexts_StoreDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7222);
/* harmony import */ var _store_cart_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2071);
/* harmony import */ var _Cart_Basket__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2114);
/* harmony import */ var _Footer_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8050);
/* harmony import */ var _Infobanner_StaticInfoBanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7103);
/* harmony import */ var _Navbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6274);
/* harmony import */ var _SideNavDrawer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5538);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2676);











var statusCopyClassName = "font-montserrat text-[16px] font-normal text-checkoutText";
/** `embedded` — already inside MainHome (banner + footer); skip duplicating them. */

var ShopStatusPage = function ShopStatusPage(_ref) {
  var message = _ref.message,
      _ref$embedded = _ref.embedded,
      embedded = _ref$embedded === void 0 ? false : _ref$embedded;

  var _useStoreContext = (0,_contexts_StoreDataContext__WEBPACK_IMPORTED_MODULE_1__/* .useStoreContext */ .Q)(),
      storeData = _useStoreContext.storeData,
      themeData = _useStoreContext.themeData;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      showSideNav = _useState[0],
      setShowSideNav = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      showCart = _useState2[0],
      setShowCart = _useState2[1];

  var hasHydrated = (0,_store_cart_store__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function (s) {
    return s.hasHydrated;
  });
  var products = (0,_store_cart_store__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function (s) {
    return s.products;
  });
  var setCart = (0,_store_cart_store__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function (s) {
    return s.setCart;
  });
  var cart = {
    products: products
  };

  var body = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: [hasHydrated && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Cart_Basket__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      isBasketOpen: showCart,
      setCart: setCart,
      cartData: cart,
      updateAddedToCart: function updateAddedToCart() {},
      handleShowCart: setShowCart,
      store: storeData,
      setRefresh: function setRefresh() {}
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Navbar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      homePage: true,
      store: storeData,
      storeName: (storeData === null || storeData === void 0 ? void 0 : storeData.name) || "",
      theme: themeData,
      toggleSideNav: function toggleSideNav() {
        return setShowSideNav(function (open) {
          return !open;
        });
      },
      sideNavOpen: showSideNav,
      handleShowCart: function handleShowCart() {
        return setShowCart(true);
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_SideNavDrawer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      isOpen: showSideNav,
      toggleDrawer: function toggleDrawer() {
        return setShowSideNav(function (open) {
          return !open;
        });
      },
      handleShowCart: function handleShowCart() {
        return setShowCart(true);
      },
      store: storeData
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
      className: "mt-8 px-5 ".concat(statusCopyClassName),
      children: message
    })]
  });

  if (embedded) return body;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
    className: "flex min-h-screen justify-center bg-[var(--side-bg-color)]",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("main", {
      className: "flex min-h-screen w-screen max-w-app flex-col bg-background font-montserrat",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Infobanner_StaticInfoBanner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        text: storeData === null || storeData === void 0 ? void 0 : storeData.announcement
      }), body, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "mt-auto",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Footer_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ShopStatusPage);

/***/ }),

/***/ 2539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2175);
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2893);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4941);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);


var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function Skeleton(_ref) {
  var className = _ref.className,
      props = (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_supports_color_8_1_1_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", _objectSpread({
    className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("animate-pulse rounded-md bg-[#ECEFF1]", className)
  }, props));
}



/***/ }),

/***/ 5161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5271);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4941);
/* harmony import */ var _Skeleton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2539);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2676);






var SkeletonCard = function SkeletonCard(_ref) {
  var _ref$imageClass = _ref.imageClass,
      imageClass = _ref$imageClass === void 0 ? "" : _ref$imageClass,
      _ref$titleClass = _ref.titleClass,
      titleClass = _ref$titleClass === void 0 ? "" : _ref$titleClass,
      _ref$descriptionClass = _ref.descriptionClass,
      descriptionClass = _ref$descriptionClass === void 0 ? "" : _ref$descriptionClass,
      _ref$containerClass = _ref.containerClass,
      containerClass = _ref$containerClass === void 0 ? "" : _ref$containerClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("flex flex-col space-y-3", containerClass),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
      className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("h-[125px] w-[250px] rounded-xl", imageClass)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "space-y-2",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("h-4 w-[250px]", titleClass)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("h-4 w-[200px]", descriptionClass)
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SkeletonCard);

/***/ }),

/***/ 2245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StoreItem; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lottie-react@2.4.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/lottie-react/build/index.umd.js
var index_umd = __webpack_require__(1682);
var index_umd_default = /*#__PURE__*/__webpack_require__.n(index_umd);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(153);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(7048);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(5271);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-lazy-load-image-component@1.6.3_react@18.3.1/node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(2027);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-lazy-load-image-component@1.6.3_react@18.3.1/node_modules/react-lazy-load-image-component/src/effects/blur.css
var effects_blur = __webpack_require__(1314);
// EXTERNAL MODULE: ./lib/cdn.js
var cdn = __webpack_require__(351);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(1485);
// EXTERNAL MODULE: ./services/frontend/pricing.service.js
var pricing_service = __webpack_require__(3726);
// EXTERNAL MODULE: ./store/search-store.js
var search_store = __webpack_require__(7413);
// EXTERNAL MODULE: ./components/Picture.jsx
var Picture = __webpack_require__(8122);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/SoldBadge.jsx


var SoldBadge = function SoldBadge(_ref) {
  var _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    className: "absolute z-10 rounded bg-[var(--theme-sold-fill)] px-1.5 py-0.5 text-xs font-semibold text-[var(--theme-sold-text)] ".concat(compact ? "bottom-1 left-1" : "bottom-2.5 left-2.5"),
    children: "Sold"
  });
};

/* harmony default export */ var components_SoldBadge = (SoldBadge);
;// CONCATENATED MODULE: ./components/shimmer.json
var shimmer_namespaceObject = JSON.parse('{"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"Randy Varianda","k":"","d":"","tc":""},"fr":16,"ip":0,"op":32,"w":128,"h":128,"nm":"Lazy Load","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[-11.5,49,0],"to":[36.083,9.667,0],"ti":[-0.25,-0.083,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":40,"s":[204.99999999999997,107,0],"to":[0.25,0.083,0],"ti":[35.833,9.583,0]},{"t":59,"s":[-10,49.5,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[179.208,93.896,100],"ix":6}},"ao":0,"ef":[{"ty":29,"nm":"Gaussian Blur","np":5,"mn":"ADBE Gaussian Blur 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Blurriness","mn":"ADBE Gaussian Blur 2-0001","ix":1,"v":{"a":0,"k":34.3,"ix":1}},{"ty":7,"nm":"Blur Dimensions","mn":"ADBE Gaussian Blur 2-0002","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"Repeat Edge Pixels","mn":"ADBE Gaussian Blur 2-0003","ix":3,"v":{"a":0,"k":0,"ix":3}}]}],"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[7.721,144.227],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.7294117647058823,0.7490196078431373,0.8666666666666667,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-18.46,3.373],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,146.624],"ix":3},"r":{"a":0,"k":20.495,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":40,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[62.458000000000006,55.823,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120.328,77.977],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.9254901960784314,0.9372549019607843,0.9450980392156862,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1.542,8.177],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[109.644,176.784],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":40,"st":0,"bm":0}],"markers":[]}');
var components_shimmer_namespaceObject = /*#__PURE__*/__webpack_require__.t(shimmer_namespaceObject, 2);
;// CONCATENATED MODULE: ./components/StoreItem.jsx
// import dynamic from "next/dynamic";
// const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

















var productStock = function productStock(product) {
  return product === null || product === void 0 ? void 0 : product.quantity;
};

var StoreItem = function StoreItem(_ref) {
  var _photos$;

  var usedForCollectionhome = _ref.usedForCollectionhome,
      product = _ref.product,
      toggleDrawer = _ref.toggleDrawer,
      search = _ref.search,
      customHeightWidth = _ref.customHeightWidth,
      variant = _ref.variant;

  var _useState = (0,react.useState)(false),
      imageLoaded = _useState[0],
      setImageLoaded = _useState[1];

  var _useState2 = (0,react.useState)(false),
      fallbackSet = _useState2[0],
      setFallbackSet = _useState2[1];

  var setShouldSearchReopen = (0,search_store/* default */.Z)(function (state) {
    return state.setShouldSearchReopen;
  });
  var router = (0,next_router.useRouter)();
  var isSimilar = variant === "similar";
  var productTitle = product === null || product === void 0 ? void 0 : product.title;
  var salePrice = product === null || product === void 0 ? void 0 : product.salePrice;
  var maxPrice = product === null || product === void 0 ? void 0 : product.maxPrice;
  var photos = (product === null || product === void 0 ? void 0 : product.photos) || [];
  var firstPhoto = typeof photos[0] === "string" ? photos[0] : (_photos$ = photos[0]) === null || _photos$ === void 0 ? void 0 : _photos$.src;
  var photoV2 = typeof photos[0] === "object" ? photos[0] : null;

  var getProductPrice = function getProductPrice(price) {
    var mrp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    if (!price) return;
    var priceClass = isSimilar ? "text-[13px] font-medium text-checkoutText" : "";
    var mrpClass = isSimilar ? "text-[13px] font-normal text-[#9CA3AF] line-through" : "text-sm font-normal line-through opacity-50";

    if (mrp) {
      var truncatedMrp = (0,pricing_service/* truncateTo2Decimals */.w)(mrp);
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: priceClass,
          children: "".concat(String.fromCharCode(0x20b9)).concat(price)
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: mrpClass,
          children: "".concat(String.fromCharCode(0x20b9)).concat(truncatedMrp)
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: priceClass,
      children: "".concat(String.fromCharCode(0x20b9)).concat(salePrice)
    });
  }; // media pipeline: compressed variants when a ready V2 entry exists (flag-gated), else today's URL.
  // Search thumbs are 70×70 — use the sidebar slot (256.avif) so we don't pull grid/orig sizes.


  var imageSlot = search ? "sidebar" : usedForCollectionhome ? "gridWide" : "grid";
  var resolved = (0,media/* resolveImage */.rs)(firstPhoto, photoV2, imageSlot);

  var getImageUrl = function getImageUrl() {
    return firstPhoto ? (0,cdn/* toCdnUrl */.V$)(firstPhoto) : "";
  };

  var checkStock = function checkStock() {
    var stock = productStock(product);
    if (typeof stock === "number") return stock > 0;
    return false;
  };

  var isFluidSquare = !isSimilar && !customHeightWidth && !usedForCollectionhome;
  var imageSizeClass = isSimilar ? "h-[156px] w-[117px]" : customHeightWidth ? customHeightWidth : usedForCollectionhome ? "h-[calc((var(--max-width)/1.5)-50px)] w-[calc((var(--max-width)/1.5)-50px)] max-w-none" : "h-full w-full";
  var itemWidthClass = isSimilar ? "w-[117px]" : usedForCollectionhome ? "mb-3 max-w-[calc((var(--max-width)/1.5)-50px)]" : "w-full";
  if (!product) return "";

  var handleProductClick = function handleProductClick(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    if (search) {
      setShouldSearchReopen(router.asPath);
    } else {
      setShouldSearchReopen(null);
    }

    if (toggleDrawer) toggleDrawer();
  };

  var productHref = "/products/".concat(product.id);

  if (search) {
    var imageUrl = getImageUrl();
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: productHref,
      prefetch: false,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        className: "flex w-full min-w-0 cursor-pointer items-start gap-x-4 text-left no-underline",
        onClick: handleProductClick,
        children: [firstPhoto ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "relative h-[70px] w-[70px] shrink-0 overflow-hidden rounded-lg border border-[#ECEFF1]",
          children: [!checkStock() ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_SoldBadge, {
            compact: true
          }) : null, resolved.isV2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
            resolved: resolved,
            alt: productTitle,
            width: 70,
            height: 70,
            imgClassName: "h-full w-full object-cover"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: imageUrl,
            alt: productTitle,
            className: "h-full w-full object-cover",
            onError: function onError(e) {
              if (!fallbackSet && firstPhoto) {
                e.target.src = firstPhoto;
                setFallbackSet(true);
              }
            }
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "h-[70px] w-[70px] shrink-0 rounded-lg border border-[#ECEFF1]"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "min-w-0",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "line-clamp-2 text-[14px] font-medium tracking-[0.75%] text-gray-900",
            children: productTitle
          }), salePrice ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "mt-1 block text-[14px] font-normal tracking-[-0.15px] text-gray-600",
            children: "".concat(String.fromCharCode(0x20b9)).concat(salePrice)
          }) : null]
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: productHref,
    prefetch: false,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: "flex w-full min-w-0 flex-col items-start justify-start overflow-hidden no-underline ".concat(itemWidthClass),
      onClick: handleProductClick,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "w-full min-w-0",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: firstPhoto ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative overflow-hidden rounded-lg border border-[#ECEFF1] ".concat(isFluidSquare ? "aspect-square w-full" : "", " ").concat(isSimilar ? imageSizeClass : ""),
            children: [!checkStock() ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_SoldBadge, {}) : null, !imageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "pointer-events-none absolute inset-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((index_umd_default()), {
                className: "h-full w-full",
                animationData: shimmer_namespaceObject || components_shimmer_namespaceObject,
                loop: true,
                autoplay: true,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice"
                }
              })
            }), resolved.isV2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
              resolved: resolved,
              alt: productTitle,
              loading: isSimilar ? "eager" : "lazy" // A hidden, 0×0 image is never requested. Safari then never fires onLoad, so this
              // style never clears and the Network panel stays empty. The shimmer sits on top.
              ,
              style: imageLoaded ? {
                cursor: "pointer"
              } : undefined,
              imgClassName: "rounded-lg object-cover ".concat(imageSizeClass),
              onLoad: function onLoad() {
                setImageLoaded(true);
              }
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(build.LazyLoadImage, {
              style: imageLoaded ? {
                cursor: "pointer"
              } : undefined,
              visibleByDefault: isSimilar,
              onLoad: function onLoad() {
                setImageLoaded(true);
              },
              onError: function onError(e) {
                if (!fallbackSet) {
                  e.target.src = "".concat(firstPhoto);
                  setFallbackSet(true);
                }
              },
              className: "rounded-lg object-cover ".concat(imageSizeClass),
              src: getImageUrl(),
              unoptimized: "true",
              objectfit: "cover",
              alt: productTitle,
              effect: customHeightWidth ? "blur" : undefined
            })]
          }) : null
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex w-full min-w-0 flex-col ".concat(isSimilar ? "mt-2" : "py-1.5"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "min-w-0 cursor-pointer text-wrap ".concat(isSimilar ? "text-[13px] font-normal text-checkoutText" : "mb-0.5 text-sm font-normal text-fontBackground opacity-70"),
            children: product && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "line-clamp-1 break-all",
              children: productTitle
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "cursor-pointer ".concat(isSimilar ? "" : "text-sm font-medium text-fontBackground"),
            children: product && getProductPrice(salePrice, maxPrice)
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var components_StoreItem = (StoreItem);

/***/ })

}]);